const TYPE_ID_COMPANY_VENDOR_HEAD = '010';
const TYPE_ID_COMPANY_VENDOR_MEMBER = '001';

export function isVendorUser(typeId: string) {
  return (
    typeId === TYPE_ID_COMPANY_VENDOR_HEAD ||
    typeId === TYPE_ID_COMPANY_VENDOR_MEMBER
  );
}
